import { render, staticRenderFns } from "./Tvapp.vue?vue&type=template&id=4452525c&scoped=true&"
import script from "./Tvapp.vue?vue&type=script&lang=js&"
export * from "./Tvapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452525c",
  null
  
)

component.options.__file = "Tvapp.vue"
export default component.exports